import type { SectionLocale } from '../types'

export const SHOP_LOCALE: SectionLocale = [
  [
    'shop_delete_item_question',
    {
      ru: 'Вы уверены, что хотите удалить товар?',
      en: 'Are you sure you want to delete this item?',
    },
  ],
  [
    'shop_restore_item_question',
    {
      ru: 'Вы уверены, что хотите восстановить товар?',
      en: 'Are you sure you want to restore this item?',
    },
  ],
  [
    'shop_dialog_cancel',
    {
      ru: 'Отменить',
      en: 'Cancel',
    },
  ],
  [
    'shop_dialog_move',
    {
      ru: 'Перенести',
      en: 'Move',
    },
  ],
  [
    'shop_archive_product_title',
    {
      ru: 'Перенести в архив?',
      en: 'Move to archive?',
    },
  ],
  [
    'shop_archive_product_message',
    {
      ru: '{item} больше не отобразится в магазине, а также нельзя будет вносить никаких изменений',
      en: '{item} will no longer be displayed in the store, and no changes can be made to it',
    },
  ],
  [
    'shop_archive_products_bulk_message',
    {
      ru: 'Выбранные товары больше не отобразятся в магазине, а также нельзя будет вносить никаких изменений',
      en: 'Selected items will no longer be displayed in the store, and no changes can be made to them',
    },
  ],
  [
    'shop_restore_product_title',
    {
      ru: 'Восстановить товар?',
      en: 'Restore item?',
    },
  ],
  [
    'shop_restore_product_message',
    {
      ru: '{item} снова отобразится в магазине, и для него можно будет вносить изменения',
      en: '{item} will be displayed in the store again, and changes can be made to it',
    },
  ],
  [
    'shop_restore_products_bulk_message',
    {
      ru: 'Выбранные товары снова отобразятся в магазине, и для них можно будет вносить изменения',
      en: 'Selected items will be displayed in the store again, and changes can be made to them',
    },
  ],
  [
    'shop_delete_attribute_question',
    {
      ru: 'Вы уверены, что хотите удалить характеристику?',
      en: 'Are you sure you want to delete this attribute?',
    },
  ],
  [
    'shop_stock_control',
    {
      ru: 'Управление наличием',
      en: 'Stock control',
    },
  ],
  [
    'shop_open_stock_control',
    {
      ru: 'Управление наличием',
      en: 'Stock control',
    },
  ],
  [
    'shop_open_attributes_control',
    {
      ru: 'Управление характеристиками',
      en: 'Manage attributes',
    },
  ],
  [
    'shop_go_to_stock_question',
    {
      ru: 'Перейти к управлению наличием?',
      en: 'Go to stock control?',
    },
  ],
  [
    'shop_add_attribute',
    {
      ru: 'Добавить характеристику',
      en: 'Add attribute',
    },
  ],
  [
    'shop_add_option',
    {
      ru: 'Добавить опцию',
      en: 'Add option',
    },
  ],
  [
    'shop_add_item',
    {
      ru: 'Добавить товар',
      en: 'Add item',
    },
  ],
  [
    'cart_out_of_stock',
    {
      ru: 'Товаров нет в наличии',
      en: 'Out of stock',
    },
  ],
  [
    'shop_item_not_found',
    {
      ru: 'Товар не найден',
      en: 'Item not found',
    },
  ],
  [
    'shop_item_out_of_stock',
    {
      ru: 'Товара нет в наличии',
      en: 'The product is out of stock',
    },
  ],
  [
    'shop-item__description',
    {
      ru: 'Описание',
      en: 'Description',
    },
  ],
  [
    'shop_editor_toolbar',
    {
      ru: 'Панель форматирования текста',
      en: 'Text formatting toolbar',
    },
  ],
  [
    'shop_editor_content_required',
    {
      ru: 'Введите описание товара',
      en: 'Enter the product description',
    },
  ],
  [
    'shop_editor_content_too_short',
    {
      ru: 'Описание товара должно содержать не менее {min} символов',
      en: 'Product description must be at least {min} characters',
    },
  ],
  [
    'shop_editor_content_too_long',
    {
      ru: 'Описание товара не должно превышать {max} символов',
      en: 'Product description must not exceed {max} characters',
    },
  ],
  [
    'shop-item__price',
    {
      ru: 'Цена',
      en: 'Price',
    },
  ],
  [
    'shop-item__photos',
    {
      ru: 'Фотографии',
      en: 'Photos',
    },
  ],
  [
    'shop_item_tags',
    {
      ru: 'Теги товара',
      en: 'Product tags',
    },
  ],
  [
    'shop_attributes',
    {
      ru: 'Характеристики',
      en: 'Attributes',
    },
  ],
  [
    'shop_attributes_empty',
    {
      ru: 'Характеристики не заполнены',
      en: 'Attributes are not filled',
    },
  ],
  [
    'shop_attributes_edit_title',
    {
      ru: 'Редактирование характеристик',
      en: 'Edit attributes',
    },
  ],
  [
    'shop_attributes_drawer_subtitle_empty',
    {
      ru: 'Можно указать не более двух характеристик товара с несколькими опциями',
      en: 'You can specify up to two product attributes with multiple options',
    },
  ],
  [
    'shop_attributes_drawer_subtitle_filled',
    {
      ru: 'Укажите все характеристики товара, а также его наличие в магазине',
      en: 'Specify all product attributes and stock availability in the shop',
    },
  ],
  [
    'shop_attribute_name_label',
    {
      ru: 'Название характеристики',
      en: 'Attribute name',
    },
  ],
  [
    'shop_attribute_name_placeholder',
    {
      ru: 'Размер, цвет, фасон и т.д.',
      en: 'Size, color, style, etc.',
    },
  ],
  [
    'shop_attribute_quantity_unit',
    {
      ru: 'шт',
      en: 'pcs',
    },
  ],
  [
    'shop_attribute_option_placeholder',
    {
      ru: 'Ввести',
      en: 'Enter',
    },
  ],
  [
    'shop_attribute_drag_handle',
    {
      ru: 'Перетащить опцию',
      en: 'Drag option',
    },
  ],
  [
    'shop_attribute_clear_name',
    {
      ru: 'Очистить название',
      en: 'Clear name',
    },
  ],
  [
    'shop_stock_matrix_title',
    {
      ru: 'Наличие',
      en: 'Availability',
    },
  ],
  [
    'shop_stock_positions_count',
    {
      ru: 'Позиций: {count}',
      en: 'Positions: {count}',
    },
  ],
  [
    'shop_stock_save_success',
    {
      ru: 'Остатки успешно сохранены',
      en: 'Stock saved successfully',
    },
  ],
  [
    'shop_stock_save_failed',
    {
      ru: 'Товар сохранён, но остатки не обновились. Нажмите «Сохранить» ещё раз.',
      en: 'The item was saved, but stock was not updated. Press Save again.',
    },
  ],
  [
    'shop_create_item_page_title',
    {
      ru: 'Создание товара',
      en: 'Create item',
    },
  ],
  [
    'shop_edit_item_page_title',
    {
      ru: 'Редактирование товара',
      en: 'Edit item',
    },
  ],
  [
    'shop-item-type__published',
    {
      ru: 'Опубликованные',
      en: 'Published',
    },
  ],
  [
    'shop-item-type__archived',
    {
      ru: 'Архивные',
      en: 'Archived',
    },
  ],
  [
    'shop-item__buy-count-base',
    {
      ru: 'Товар купили:',
      en: 'Purchased:',
    },
  ],
  // deprecated: оставлено на всякий случай, как фолбек. правильный ключ `order_state_waits_for_confirmation`
  [
    'order_state_waits_for_confirmation',
    {
      ru: 'Ожидает подтверждения',
      en: 'Waiting for confirmation',
    },
  ],
  [
    'order_state_confirmed',
    {
      ru: 'Подтверждён',
      en: 'Confirmed',
    },
  ],
  [
    'order_state_shipped',
    {
      ru: 'Отправлен',
      en: 'Shipped',
    },
  ],
  [
    'order_state_completed',
    {
      ru: 'Доставлен',
      en: 'Completed',
    },
  ],
  [
    'order_state_cancelled',
    {
      ru: 'Отменён',
      en: 'Cancelled',
    },
  ],
  [
    'back_to_shop',
    {
      ru: 'Назад в магазин',
      en: 'Back to shop',
    },
  ],
  [
    'back_to_product',
    {
      ru: 'Вернуться к карточке товара',
      en: 'Back to product',
    },
  ],
  [
    'orders_badge',
    {
      ru: 'Заказы',
      en: 'Orders',
    },
  ],
  [
    'my_orders_badge',
    {
      ru: 'Мои заказы',
      en: 'My orders',
    },
  ],
  [
    'cancel_order',
    {
      ru: 'Отменить заказ',
      en: 'Cancel order',
    },
  ],
  [
    'cancel_order_question',
    {
      ru: 'Вы уверены, что хотите отменить заказ?',
      en: 'Are you sure you want to cancel the order?',
    },
  ],
  [
    'cancel_order_question_admin',
    {
      ru: 'Вы уверены, что хотите отменить заказ? Коины вернуться на счет покупателю, а количество товара на складе пополнится.',
      en: "Are you sure you want to cancel the order? Coins will be returned to the buyer's account, and the quantity of the product will be replenished on the warehouse.",
    },
  ],

  [
    'order_from',
    {
      ru: 'От',
      en: 'Dated',
    },
  ],
  [
    'orders_filter',
    {
      ru: 'Фильтр по статусу',
      en: 'Filter by status',
    },
  ],
  [
    'orders_empty',
    {
      ru: 'Список заказов пуст',
      en: 'Orders list is empty',
    },
  ],
  [
    'orders_not_found',
    {
      ru: 'Заказы не найдены',
      en: 'Orders not found',
    },
  ],
  [
    'orders_add_track_code',
    {
      ru: 'Добавить трек-код',
      en: 'Add track code',
    },
  ],
  [
    'orders_add_track_code_title',
    {
      ru: 'Добавьте трек-код',
      en: 'Add a track code',
    },
  ],
  [
    'orders_edit_track_code_title',
    {
      ru: 'Редактирование кода',
      en: 'Edit track code',
    },
  ],
  [
    'orders_track_code_save_success',
    {
      ru: 'Трек код успешно сохранен',
      en: 'Track code saved successfully',
    },
  ],
  [
    'orders_delivery_service_url_save_success',
    {
      ru: 'Ссылка на трекинг сервис успешно сохранена',
      en: 'Tracking service link saved',
    },
  ],
  [
    'orders_add_track_code_description',
    {
      ru: 'Здесь можно указать актуальный код, по которому можно отслеживать статус заказа. Обратите внимание, что после сохранения изменить его нельзя.',
      en: 'Here you can specify the actual code used to track the order status. Please note that it cannot be changed after saving.',
    },
  ],
  [
    'orders_add_track_code_description_admin',
    {
      ru: 'Здесь можно указать актуальный код, по которому можно отслеживать статус заказа.',
      en: 'Here you can specify the actual code used to track the order status.',
    },
  ],
  [
    'orders_add_track_code_label',
    {
      ru: 'Трек-код',
      en: 'Track code',
    },
  ],
  [
    'orders_delivery_service_url_label',
    {
      ru: 'Ссылка на сервис доставки',
      en: 'Delivery service link',
    },
  ],
  [
    'orders_delivery_service_url_placeholder',
    {
      ru: 'Укажите ссылку на сервис для отслеживания посылки',
      en: 'Enter a tracking service link',
    },
  ],
  [
    'orders_delivery_service_url_invalid',
    {
      ru: 'Укажите корректный HTTPS URL',
      en: 'Enter a valid HTTPS URL',
    },
  ],
  [
    'orders_search_placeholder',
    {
      ru: 'Поиск по товару или пользователю',
      en: 'Search by product or user',
    },
  ],
  [
    'orders_track_order',
    {
      ru: 'Отследить заказ',
      en: 'Track order',
    },
  ],
  [
    'orders_copy_track_code',
    {
      ru: 'Скопировать трек-код',
      en: 'Copy track code',
    },
  ],
  [
    'orders_copy_track_code_succeed',
    {
      ru: 'Трек код скопирован',
      en: 'Track code copied',
    },
  ],
  [
    'orders_copy_track_code_failed',
    {
      ru: 'Не удалось скопировать трек код',
      en: 'Failed to copy track code',
    },
  ],
  [
    'orders_details_title',
    {
      ru: 'Заказ № {n}',
      en: 'Order № {n}',
    },
  ],
  [
    'orders_composition',
    {
      ru: 'Состав заказа',
      en: 'Order items',
    },
  ],
  [
    'orders_total',
    {
      ru: 'Итого',
      en: 'Total',
    },
  ],
  [
    'orders_quantity_short',
    {
      ru: '{n} шт',
      en: '{n} pcs',
    },
  ],
  [
    'orders_cancel_title',
    {
      ru: 'Отменить заказ?',
      en: 'Cancel order?',
    },
  ],
  [
    'orders_cancel_message',
    {
      ru: 'После отмены заказа, вся сумма заказа будет возвращена на ваш баланс.',
      en: 'After canceling the order, the full order amount will be returned to your balance.',
    },
  ],
  [
    'orders_user_deactivated',
    {
      ru: 'Деактивирован',
      en: 'Deactivated',
    },
  ],
  [
    'orders_export_orders',
    {
      ru: 'Экспорт заказов',
      en: 'Export orders',
    },
  ],
  [
    'orders_export_select_date_range',
    {
      ru: 'Выберите диапазон дат для экспорта',
      en: 'Select a date range for export',
    },
  ],
  [
    'orders_export_orders_error',
    {
      ru: 'Ошибка экспорта заказов. Пожалуйста, повторите позже',
      en: 'Failed to export the orders. Please try again later',
    },
  ],
  [
    'orders_sort_newest_first',
    {
      ru: 'Сначала новые',
      en: 'Newest first',
    },
  ],
  [
    'orders_sort_oldest_first',
    {
      ru: 'Сначала старые',
      en: 'Oldest first',
    },
  ],
  [
    'orders_management_title',
    {
      ru: 'Заказы сотрудников',
      en: 'Employee orders',
    },
  ],
  [
    'orders_management_search_placeholder',
    {
      ru: 'Поиск по номеру, товару и сотруднику',
      en: 'Search by number, product, and employee',
    },
  ],
  [
    'orders_management_export',
    {
      ru: 'Экспорт заказов',
      en: 'Export orders',
    },
  ],
  [
    'orders_management_column_order',
    {
      ru: 'Заказ',
      en: 'Order',
    },
  ],
  [
    'orders_management_column_date',
    {
      ru: 'Дата',
      en: 'Date',
    },
  ],
  [
    'orders_management_column_employee',
    {
      ru: 'Сотрудник',
      en: 'Employee',
    },
  ],
  [
    'orders_management_column_products',
    {
      ru: 'Товары',
      en: 'Products',
    },
  ],
  [
    'orders_management_column_sum',
    {
      ru: 'Сумма',
      en: 'Amount',
    },
  ],
  [
    'orders_management_column_status',
    {
      ru: 'Статус заказа',
      en: 'Order status',
    },
  ],
  [
    'orders_management_row_menu_aria',
    {
      ru: 'Действия с заказом',
      en: 'Order actions',
    },
  ],
  [
    'orders_management_action_details',
    {
      ru: 'Детали заказа',
      en: 'Order details',
    },
  ],
  [
    'orders_management_action_change_status',
    {
      ru: 'Изменить статус',
      en: 'Change status',
    },
  ],
  [
    'orders_management_action_track_code',
    {
      ru: 'Трек-код',
      en: 'Track code',
    },
  ],
  [
    'orders_management_action_copy_reddy',
    {
      ru: 'Скопировать Reddy',
      en: 'Copy Reddy',
    },
  ],
  [
    'orders_management_copy_reddy_failed',
    {
      ru: 'Не удалось скопировать Reddy',
      en: 'Failed to copy Reddy',
    },
  ],
  [
    'orders_management_empty_list',
    {
      ru: 'Список заказов пуст',
      en: 'Orders list is empty',
    },
  ],
  [
    'orders_management_reset_filters',
    {
      ru: 'Сбросить фильтры',
      en: 'Reset filters',
    },
  ],
  [
    'orders_management_pagination_show_records',
    {
      ru: 'Показать {count} записей',
      en: 'Show {count} records',
    },
  ],
  [
    'shop_in_stock',
    {
      ru: 'В наличии',
      en: 'In stock',
    },
  ],
  [
    'shop_total_in_warehouse',
    {
      ru: 'Всего на складе',
      en: 'Total in warehouse',
    },
  ],
  [
    'shop_total_items',
    {
      ru: 'Всего товара',
      en: 'Total items',
    },
  ],
  [
    'shop_manage_stock',
    {
      ru: 'Управлять',
      en: 'Manage',
    },
  ],
  [
    'shop_search_placeholder',
    {
      ru: 'Поиск товара',
      en: 'Search products',
    },
  ],
  [
    'shop_edit_item',
    {
      ru: 'Редактировать',
      en: 'Edit',
    },
  ],
  [
    'shop_delete_item',
    {
      ru: 'В архив',
      en: 'Into archive',
    },
  ],
  [
    'shop_restore_item',
    {
      ru: 'Восстановить',
      en: 'Restore',
    },
  ],
  [
    'shop_get_item',
    {
      ru: 'Заказать',
      en: 'Order',
    },
  ],
  [
    'shop_go_to_cart',
    {
      ru: 'Перейти в корзину',
      en: 'Go to cart',
    },
  ],
  [
    'shop_edit_title',
    {
      ru: 'Название товара',
      en: 'Item title',
    },
  ],
  [
    'shop_edit_attribute',
    {
      ru: 'Характеристика',
      en: 'Attribute',
    },
  ],
  [
    'shop_edit_option',
    {
      ru: 'Опция',
      en: 'Option',
    },
  ],
  [
    'transaction_comment',
    {
      ru: 'Комментарий',
      en: 'Comment',
    },
  ],
  [
    'transaction_type_deposit',
    {
      ru: 'Ежемесячные начисления',
      en: 'Monthly accruals',
    },
  ],
  [
    'transaction_type_purchase',
    {
      ru: 'Покупка',
      en: 'Purchase',
    },
  ],
  [
    'transaction_type_refund',
    {
      ru: 'Возврат',
      en: 'Refund',
    },
  ],
  [
    'transaction_type_transfer_out',
    {
      ru: 'Начисление другому сотруднику',
      en: 'Accruals to another employee',
    },
  ],
  [
    'transaction_type_transfer_in',
    {
      ru: 'Начисление от другого сотрудника',
      en: 'Accruals from another employee',
    },
  ],
  [
    'cart_heading',
    {
      ru: 'Корзина',
      en: 'Cart',
    },
  ],
  [
    'shop_heading',
    {
      ru: 'Магазин',
      en: 'Shop',
    },
  ],
  [
    'cart_order',
    {
      ru: 'Заказать',
      en: 'Order',
    },
  ],
  [
    'cart_delivery_details_title',
    {
      ru: 'Детали доставки',
      en: 'Delivery details',
    },
  ],
  [
    'cart_delivery_details_description_months',
    {
      ru: 'Обратите внимание: доставка посылки может занять до 3 месяцев. Пожалуйста, подтвердите корректность адреса получения',
      en: 'Please note: parcel delivery may take up to 3 months. Please confirm that the recipient address is correct',
    },
  ],
  [
    'cart_delivery_details_description_weeks',
    {
      ru: 'Обратите внимание: доставка посылки может занять до 2 недель. Пожалуйста, подтвердите корректность адреса получения',
      en: 'Please note: parcel delivery may take up to 2 weeks. Please confirm that the recipient address is correct',
    },
  ],
  [
    'cart_delivery_details_latin_only_notice',
    {
      ru: 'Адрес должен быть указан латиницей:',
      en: 'Address in Latin characters only:',
    },
  ],
  [
    'cart_delivery_country_prompt',
    {
      ru: 'Укажите страну',
      en: 'Specify country',
    },
  ],
  [
    'cart_delivery_city_prompt',
    {
      ru: 'Укажите город',
      en: 'Specify city',
    },
  ],
  [
    'cart_delivery_street_prompt',
    {
      ru: 'Укажите улицу',
      en: 'Specify street',
    },
  ],
  [
    'cart_delivery_index_prompt',
    {
      ru: 'Укажите индекс',
      en: 'Specify zip code',
    },
  ],
  [
    'cart_delivery_phone_prompt',
    {
      ru: 'Укажите номер получателя',
      en: 'Specify recipient phone',
    },
  ],
  [
    'cart_delivery_email_prompt',
    {
      ru: 'Укажите email получателя',
      en: 'Specify recipient email',
    },
  ],
  [
    'cart_delivery_phone_search_placeholder',
    {
      ru: 'Поиск страны',
      en: 'Search country',
    },
  ],
  [
    'cart_delivery_phone_search_empty_state',
    {
      ru: 'Нет подходящих результатов',
      en: 'No results found',
    },
  ],
  [
    'cart_clear',
    {
      ru: 'Очистить корзину',
      en: 'Clear cart',
    },
  ],
  [
    'cart_order_details',
    {
      ru: 'Детали заказа',
      en: 'Order details',
    },
  ],
  [
    'cart_delivery_time_title',
    {
      ru: 'Время доставки',
      en: 'Delivery time',
    },
  ],
  [
    'cart_delivery_time_text_months',
    {
      ru: 'Обратите внимание: доставка посылки может занять до 3 месяцев',
      en: 'Please note: delivery may take up to 3 months',
    },
  ],
  [
    'cart_delivery_time_text_weeks',
    {
      ru: 'Обратите внимание: доставка посылки может занять до 2 недель',
      en: 'Please note: delivery may take up to 2 weeks',
    },
  ],
  [
    'cart_total_amount',
    {
      ru: 'Сумма',
      en: 'Total',
    },
  ],
  [
    'cart_insufficient_funds',
    {
      ru: 'Недостаточно денег на балансе',
      en: 'Insufficient funds on balance',
    },
  ],
  [
    'cart_empty_text',
    {
      ru: 'В корзине пусто. Надо что-то прикупить',
      en: 'Your cart is empty. Time to do some shopping',
    },
  ],
  [
    'cart_go_to_shop',
    {
      ru: 'Перейти в магазин',
      en: 'Go to shop',
    },
  ],
  [
    'cart_coin_alt',
    {
      ru: 'Монета',
      en: 'Coin',
    },
  ],
  [
    'cart_empty_image_alt',
    {
      ru: 'Пустая корзина',
      en: 'Empty cart',
    },
  ],
  [
    'cart_delivery_address',
    {
      ru: 'Адрес доставки',
      en: 'Delivery address',
    },
  ],
  [
    'cart_specify_delivery_address',
    {
      ru: 'Указать адрес доставки',
      en: 'Specify delivery address',
    },
  ],
  [
    'cart_confirm_address_title',
    {
      ru: 'Подтвердите адрес',
      en: 'Confirm address',
    },
  ],
  [
    'cart_we_will_send_to_address',
    {
      ru: 'Мы отправим мерч на адрес',
      en: 'We will send the merch to the address',
    },
  ],
  [
    'cart_is_address_correct_question',
    {
      ru: 'Адрес указан верно?',
      en: 'Is the address correct?',
    },
  ],
  [
    'cart_no_address_question',
    {
      ru: 'Адрес доставки не указан. Хотите изменить?',
      en: 'Delivery address is not set. Do you want to change it?',
    },
  ],
  [
    'cart_continue',
    {
      ru: 'Продолжить',
      en: 'Continue',
    },
  ],
  [
    'cart_specify_other_address',
    {
      ru: 'Указать другой адрес',
      en: 'Specify another address',
    },
  ],
  [
    'cart_balance_aria',
    {
      ru: 'Доступный баланс: {amount}',
      en: 'Available balance: {amount}',
    },
  ],
  [
    'cart_close_dialog_aria',
    {
      ru: 'Закрыть диалог',
      en: 'Close dialog',
    },
  ],
  [
    'cart_remove_item_aria',
    {
      ru: 'Удалить товар «{name}» из корзины',
      en: 'Remove item “{name}” from cart',
    },
  ],
  [
    'cart_section_items_aria',
    {
      ru: 'Товары в корзине',
      en: 'Cart items',
    },
  ],
  [
    'cart_section_summary_aria',
    {
      ru: 'Итоги заказа',
      en: 'Order summary',
    },
  ],
  [
    'page_title_tags_control',
    {
      ru: 'Управление тэгами',
      en: 'Tags control',
    },
  ],
  [
    'tags_section_title',
    {
      ru: 'Теги',
      en: 'Tags',
    },
  ],
  [
    'tags_section_subtitle',
    {
      ru: 'Укажите здесь теги, которые помогут сортировать товар в магазине мерча',
      en: 'Specify tags here that will help sort products in the merch shop',
    },
  ],
  [
    'tags_add_tag',
    {
      ru: 'Добавить тег',
      en: 'Add tag',
    },
  ],
  [
    'tags_name_placeholder',
    {
      ru: 'Название тега',
      en: 'Tag name',
    },
  ],
  [
    'tags_delete_question',
    {
      ru: 'Хотите удалить этот тег?',
      en: 'Do you want to delete this tag?',
    },
  ],
  [
    'tags_control_load_error',
    {
      ru: 'Не удалось загрузить теги',
      en: 'Failed to load tags',
    },
  ],
  [
    'tags_control_save_success',
    {
      ru: 'Теги успешно сохранены',
      en: 'Tags successfully saved',
    },
  ],
  [
    'tags_control_save_error',
    {
      ru: 'Не удалось сохранить теги',
      en: 'Failed to save tags',
    },
  ],
  [
    'tags_add-label',
    {
      ru: '+ Добавить тэг',
      en: '+ Add tag',
    },
  ],
  [
    'tags_select-placeholder',
    {
      ru: 'Выберите тэг',
      en: 'Select tag',
    },
  ],
  [
    'tags_all-items',
    {
      ru: 'Все товары',
      en: 'All items',
    },
  ],
  [
    'shop_item_out_of_stock_error',
    {
      ru: 'Товара нет в наличии',
      en: 'The product is out of stock',
    },
  ],
  [
    'shop_actualize-cart-error',
    {
      ru: 'Не удалось актуализировать данные для корзины',
      en: 'Failed to actualize cart data',
    },
  ],
  [
    'shop_items_added',
    {
      ru: 'Товар(ы) добавлен(ы) в корзину',
      en: 'The product(s) was added to cart',
    },
  ],
  [
    'shop_cart_some_items_out_of_stock',
    {
      ru: 'Некоторые товары в корзине закончились',
      en: 'Some items in the cart are out of stock',
    },
  ],
  [
    'coins_allocated_successfully',
    {
      ru: 'Коины успешно начислены',
      en: 'Coins successfully allocated',
    },
  ],
  [
    'coins_allocated_error',
    {
      ru: 'Ошибка при начислении коинов',
      en: 'Error allocating coins',
    },
  ],
  [
    'coins_withdraw_successfully',
    {
      ru: 'Коины успешно списаны',
      en: 'Coins successfully withdrawn',
    },
  ],
  [
    'shop_order_item_points_short',
    {
      ru: 'шт',
      en: 'pt',
    },
  ],
  [
    'shop_export_stock_levels',
    {
      ru: 'Экспорт остатков',
      en: 'Export Stock',
    },
  ],
  [
    'shop_export_stock_error',
    {
      ru: 'Ошибка экспорта остатков. Пожалуйста, повторите позже',
      en: 'Failed to export the stock. Please try again later',
    },
  ],
  [
    'shop_search-placeholder',
    {
      ru: 'Найти товар',
      en: 'Find a store item',
    },
  ],
  [
    'shop_item-out-of-stock',
    {
      ru: 'Нет на складе',
      en: 'Out of stock',
    },
  ],
  [
    'shop_list-showed',
    {
      ru: 'Показано {items} из {total} продуктов',
      en: 'Show {items} from {total} items',
    },
  ],

  [
    'shop_add-merch-title',
    {
      ru: 'Нет ничего подходящего?',
      en: 'Nothing suitable?',
    },
  ],
  [
    'shop_add-merch-description',
    {
      ru: 'Предложи свой мерчи мы постараемся добавить его в магазин',
      en: "Suggest your merch and we'll try to add it to the store.",
    },
  ],
  [
    'shop_add-merch-button',
    {
      ru: 'Предложить мерч',
      en: 'Suggest merch',
    },
  ],
  [
    'shop_item-bought',
    {
      ru: 'Купили',
      en: 'Bought',
    },
  ],
  [
    'shop_item-bought-times',
    {
      ru: 'раз',
      en: 'times',
    },
  ],
  [
    'shop_aria_main',
    {
      ru: 'Магазин',
      en: 'Shop',
    },
  ],
  [
    'shop_aria_products_list',
    {
      ru: 'Список товаров',
      en: 'Products list',
    },
  ],
  [
    'shop_aria_categories_filter',
    {
      ru: 'Фильтр по категориям',
      en: 'Categories filter',
    },
  ],
  [
    'shop_aria_search_panel',
    {
      ru: 'Панель поиска',
      en: 'Search panel',
    },
  ],
  [
    'shop_aria_category_filter',
    {
      ru: 'Фильтр по категории {name}',
      en: 'Filter by category {name}',
    },
  ],
  [
    'shop_aria_loading_more',
    {
      ru: 'Загрузка дополнительных товаров',
      en: 'Loading more products',
    },
  ],

  [
    'shop_aria_progress_loaded',
    {
      ru: 'Загружено товаров',
      en: 'Products loaded',
    },
  ],
  [
    'shop_aria_clear_search',
    {
      ru: 'Очистить поиск',
      en: 'Clear search',
    },
  ],
  [
    'shop_aria_cart',
    {
      ru: 'Корзина, товаров: {count}',
      en: 'Cart, items: {count}',
    },
  ],
  [
    'shop_aria_balance',
    {
      ru: 'Текущий баланс: {balance}',
      en: 'Current balance: {balance}',
    },
  ],
  [
    'shop_aria_open_suggest_merch',
    {
      ru: 'Открыть предложение мерча',
      en: 'Open merch suggestion',
    },
  ],
  [
    'shop_aria_close_suggest_merch',
    {
      ru: 'Закрыть предложение мерча',
      en: 'Close merch suggestion',
    },
  ],

  [
    'shop-suggest_heading',
    {
      ru: 'Предложи мерч',
      en: 'Suggest a merch',
    },
  ],

  [
    'shop-suggest_heading',
    {
      ru: 'Предложи мерч',
      en: 'Suggest a merch',
    },
  ],
  [
    'shop_update-address-error',
    {
      ru: 'Ошибка при попытке изменить адрес доставки',
      en: 'Error while trying to change delivery address occured',
    },
  ],
  [
    'shop-suggest_send-error',
    {
      ru: 'Ошибка при попытке предложить мерч',
      en: 'An error occurred when try to send suggest',
    },
  ],
  [
    'shop-suggest_cancel-message',
    {
      ru: 'Вы действительно хотите отменить все изменения?',
      en: 'Are you sure you want to discard all changes?',
    },
  ],
  [
    'shop-suggest_send-success',
    {
      ru: 'Предложение отправлено',
      en: 'Suggest sent',
    },
  ],
  [
    'shop-suggest_send-error',
    {
      ru: 'Ошибка при попытке предложить мерч',
      en: 'An error occured when try to send suggest',
    },
  ],
  [
    'shop-suggest_cancel-message',
    {
      ru: 'Вы действительно хотите отменить все изменения?',
      en: 'Are you sure you want to discard all changes?',
    },
  ],
  [
    'shop-suggest_send-success',
    {
      ru: 'Предложение отправлено',
      en: 'Suggest sent',
    },
  ],
  [
    'shop-suggest_send-error',
    {
      ru: 'Ошибка при попытке предложить мерч',
      en: 'An error occurred when try to send suggest',
    },
  ],
  [
    'shop-suggest_cancel-message',
    {
      ru: 'Вы действительно хотите отменить все изменения?',
      en: 'Are you sure you want to discard all changes?',
    },
  ],
  [
    'shop-suggest_send-success',
    {
      ru: 'Предложение отправлено',
      en: 'Suggest sent',
    },
  ],
  [
    'shop-suggest_send-error',
    {
      ru: 'Ошибка при попытке предложить мерч',
      en: 'An error occured when try to send suggest',
    },
  ],
  [
    'shop-suggest_cancel-message',
    {
      ru: 'Вы действительно хотите отменить все изменения?',
      en: 'Are you sure you want to discard all changes?',
    },
  ],
  [
    'shop-suggest_send-success',
    {
      ru: 'Предложение отправлено',
      en: 'Suggest sent',
    },
  ],
  [
    'page_title_shop_management',
    {
      ru: 'Управление товарами',
      en: 'Product management',
    },
  ],
  [
    'shop_management_add_product',
    {
      ru: 'Добавить новый товар',
      en: 'Add new product',
    },
  ],
  [
    'shop_management_move_to_archive',
    {
      ru: 'Перенести в архив',
      en: 'Move to archive',
    },
  ],
  [
    'shop_management_row_menu_aria',
    {
      ru: 'Действия с товаром',
      en: 'Product actions',
    },
  ],
  [
    'shop_management_new_label',
    {
      ru: 'Новый лейбл',
      en: 'New label',
    },
  ],
  [
    'shop_management_add_label_title',
    {
      ru: 'Добавить лейбл',
      en: 'Add label',
    },
  ],
  [
    'shop_management_add_label_label',
    {
      ru: 'Название',
      en: 'Label',
    },
  ],
  [
    'shop_management_add_label_duplicate',
    {
      ru: 'Такой лейбл уже существует',
      en: 'This label already exists',
    },
  ],
  [
    'shop_management_add_label_placeholder',
    {
      ru: 'Введите название',
      en: 'Enter name',
    },
  ],
  [
    'shop_management_label_filter_placeholder',
    {
      ru: 'Категория',
      en: 'Category',
    },
  ],
  [
    'shop_management_label_none',
    {
      ru: 'Нет категории',
      en: 'No category',
    },
  ],
  [
    'shop_management_column_id',
    {
      ru: 'ID',
      en: 'ID',
    },
  ],
  [
    'shop_management_column_product',
    {
      ru: 'Товар',
      en: 'Product',
    },
  ],
  [
    'shop_management_column_cost',
    {
      ru: 'Стоимость',
      en: 'Cost',
    },
  ],
  [
    'shop_management_column_total_stock',
    {
      ru: 'Всего в наличии',
      en: 'Total in stock',
    },
  ],
  [
    'shop_management_open_stock_drawer',
    {
      ru: 'Редактировать остатки товара №{id}',
      en: 'Edit stock for product #{id}',
    },
  ],
  [
    'shop_management_column_label',
    {
      ru: 'Лейбл',
      en: 'Label',
    },
  ],
  [
    'shop_management_empty_list',
    {
      ru: 'Товары не найдены',
      en: 'No products found',
    },
  ],
  [
    'shop_management_reset_filters',
    {
      ru: 'Сбросить фильтры',
      en: 'Reset filters',
    },
  ],
  [
    'shop_cart_actualize_error',
    {
      ru: 'Не удалось обновить корзину',
      en: 'Failed to update the cart',
    },
  ],
  [
    'shop_cart_forbidden',
    {
      ru: 'Нет доступа к товарам магазина',
      en: 'You do not have access to shop products',
    },
  ],
  [
    'shop_cart_invalid_product_id',
    {
      ru: 'Некорректный товар в корзине',
      en: 'Invalid item in your cart',
    },
  ],
  [
    'shop_cart_product_not_found',
    {
      ru: 'Товар в корзине больше недоступен',
      en: 'An item in your cart is no longer available',
    },
  ],
  [
    'shop_cart_unauthorized',
    {
      ru: 'Сессия истекла. Войдите снова',
      en: 'Your session has expired. Please sign in again',
    },
  ],
  [
    'shop_order_create_error',
    {
      ru: 'Не удалось оформить заказ. Попробуйте ещё раз',
      en: 'Failed to place the order. Please try again',
    },
  ],
  [
    'shop_order_empty_cart',
    {
      ru: 'Корзина пуста или нет доступных товаров',
      en: 'The cart is empty or there are no available products',
    },
  ],
  [
    'shop_order_invalid_address',
    {
      ru: 'Заполните адрес доставки',
      en: 'Please fill in the delivery address',
    },
  ],
  [
    'shop_order_invalid_email',
    {
      ru: 'Некорректный email. Проверьте адрес и попробуйте ещё раз',
      en: 'Invalid email address. Please check and try again',
    },
  ],
  [
    'shop_order_invalid_phone',
    {
      ru: 'Некорректный номер телефона. Проверьте номер и попробуйте ещё раз',
      en: 'Invalid phone number. Please check the number and try again',
    },
  ],
  [
    'shop_order_invalid_postal_code',
    {
      ru: 'Индекс не должен быть длиннее {max} символов',
      en: 'Postal code must be at most {max} characters',
    },
  ],
  [
    'shop_order_invalid_quantity',
    {
      ru: 'Количество должно быть больше нуля',
      en: 'Quantity must be greater than zero',
    },
  ],
  [
    'shop_order_no_active_billing_period',
    {
      ru: 'Нет активного биллинг-периода',
      en: 'No active billing period',
    },
  ],
  [
    'shop_order_not_enough_coins',
    {
      ru: 'Недостаточно коинов для оформления заказа',
      en: 'Not enough coins to place the order',
    },
  ],
  [
    'shop_order_not_enough_stock',
    {
      ru: 'Недостаточно товара на складе',
      en: 'Not enough stock available',
    },
  ],
  [
    'shop_order_product_not_found',
    {
      ru: 'Товар не найден',
      en: 'Product not found',
    },
  ],
  [
    'shop_order_required_field',
    {
      ru: 'Заполните обязательные поля',
      en: 'Please fill in the required fields',
    },
  ],
  [
    'shop_order_sku_not_found',
    {
      ru: 'Вариант товара не найден',
      en: 'Product variant not found',
    },
  ],
  [
    'shop_order_wrong_amount',
    {
      ru: 'Сумма заказа должна быть больше нуля',
      en: 'Order amount must be greater than zero',
    },
  ],
  [
    'shop_order_contact_information',
    {
      ru: 'Контактные данные получателя',
      en: "Recipient's contact information",
    },
  ],
]
